export default [
    "18 18",
    '<path d="M2.25 9.24634H15.75M2.25 4.74634H15.75M2.25 13.7463H15.75" fill="none" stroke="var(--ci-primary-color, currentColor)"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]

